import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
import HeadlessHostedInputOptionsStyle from './headlessHostedInputOptionsStyle.mdx';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Group = makeShortcode("Group");
const Item = makeShortcode("Item");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Group summary="HeadlessHostedInputOptions" mdxType="Group">
	<Item title='placeholder' subtitle='string' mdxType="Item">
		Optional placeholder text to display in the input element.
	</Item>
	<Item title='ariaLabel' subtitle='string' mdxType="Item">
		Optional text for the input's aria-label attribute to improve accessibility.
	</Item>
	<Item title='style' subtitle='CheckoutStyle' mdxType="Item">
		<HeadlessHostedInputOptionsStyle mdxType="HeadlessHostedInputOptionsStyle" />
	</Item>
    </Group>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      